import { TopUpOrderStatus } from '../../enums/TopUpOrderStatus';
import { TopUpOrder as TopUpOrderI } from '../types/TopUpOrder';

export class TopUpOrder implements TopUpOrderI {
    topUpOrderId?: number | undefined;

    mchName?: string | undefined;

    topUpBankId?: string | undefined;

    topUpBank?: string | undefined;

    orderNum?: string | undefined;

    topUpSource?: string | undefined;

    creater?: string | undefined;

    reviewer?: string | undefined;

    evidence: string[] = [];

    remark?: string | undefined;

    updateTime?: string | undefined;

    createTime?: string | undefined;

    topUpAmt = 0;

    receivedAmt = 0;

    platFee = 0;

    topUpStatus: TopUpOrderStatus = TopUpOrderStatus.Default;

    topUpStatusMsg: string | undefined;
}
